export const validationPopup = (details) => ({
  type: "SHOW_VALIDATION_POPUP",
  payload: details,
});
export const hideValidationPopup = () => ({
  type: "HIDE_VALIDATION_POPUP",
});

export const showPopup = (name) => ({
  type: "SHOW_POPUP",
  payload: name,
});

export const hidePopup = () => ({
  type: "HIDE_POPUP",
});

// Reset password popup actions
export const showForgotPasswordPopup = () => ({
  type: "SHOW_FORGOT_PASSWORD_POPUP",
});

export const hideForgotPasswordPopup = () => ({
  type: "HIDE_FORGOT_PASSWORD_POPUP",
});

export const showCheckEmailPopup = () => ({
  type: "SHOW_CHECK_EMAIL_POPUP",
});

export const hideCheckEmailPopup = () => ({
  type: "HIDE_CHECK_EMAIL_POPUP",
});

export const showResetPasswordPopup = (resetToken) => ({
  type: "SHOW_RESET_PASSWORD_POPUP",
  payload: resetToken,
});

export const hideResetPasswordPopup = () => ({
  type: "HIDE_RESET_PASSWORD_POPUP",
});

export const showPasswordResetSuccessPopup = () => ({
  type: "SHOW_PASSWORD_RESET_SUCCESS_POPUP",
});

export const hidePasswordResetSuccessPopup = () => ({
  type: "HIDE_PASSWORD_RESET_SUCCESS_POPUP",
});
export const setUserToken = (token) => ({
  type: "SET_USER_TOKEN",
  payload: token,
});
